module.exports = __webpack_public_path__ + "img/DE02760.0b7ddf91.png";